"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OcrStatusEnum = exports.InboxInvoiceStatusEnum = void 0;
var InboxInvoiceStatusEnum;
(function (InboxInvoiceStatusEnum) {
    InboxInvoiceStatusEnum[InboxInvoiceStatusEnum["UPLOADED"] = 0] = "UPLOADED";
    InboxInvoiceStatusEnum[InboxInvoiceStatusEnum["PROCESSED"] = 1] = "PROCESSED";
    InboxInvoiceStatusEnum[InboxInvoiceStatusEnum["PROCESSING"] = 2] = "PROCESSING";
    InboxInvoiceStatusEnum[InboxInvoiceStatusEnum["FAILED"] = 3] = "FAILED";
})(InboxInvoiceStatusEnum || (exports.InboxInvoiceStatusEnum = InboxInvoiceStatusEnum = {}));
var OcrStatusEnum;
(function (OcrStatusEnum) {
    OcrStatusEnum[OcrStatusEnum["STARTED"] = 0] = "STARTED";
    OcrStatusEnum[OcrStatusEnum["FINISHED"] = 1] = "FINISHED";
    OcrStatusEnum[OcrStatusEnum["FAILED"] = 2] = "FAILED";
})(OcrStatusEnum || (exports.OcrStatusEnum = OcrStatusEnum = {}));
